import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { BrowserRouter as Browser } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import 'mapbox-gl/dist/mapbox-gl.css'
import "./index.css";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Browser>
      <Provider store={store}>
        <App />
      </Provider>
    </Browser>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
